export const FETCH_PREVIEW_DETAILS = 'FETCH_PREVIEW_DETAILS'
export const FETCH_PREVIEW_DETAILS_REQUEST = 'FETCH_PREVIEW_DETAILS_REQUEST'
export const FETCH_PREVIEW_DETAILS_SUCCESS = 'FETCH_PREVIEW_DETAILS_SUCCESS'